<template>
  <div class="loginPage">
    <div class="login-leftBox">
      <img class="login-graphic" src="@/assets/image/LoginPage_Graphic.png"/>
    </div>
    <div class = "login-rightBox" style="position: relative; min-height: 100vh;">
      <p class="center">賽馬會翻轉教學平台</p>
      <img src="@/assets/image/logo/fabulearn_h.png" />
      <div v-if="!emailSent">
        <p class="center" style="font-size: 1.5rem;font-weight: 600">忘記密碼</p>
        <div class="">
          <div class="loginform-input">
            <div class="loginform-label">
              <label>電郵:</label>
            </div>
            <div class="loginform-field" >
              <input v-model="email" type="text" name="login_id">
            </div>
          </div>
        </div>
        <div class="loginform-btns">
          <div class="greenText textbtn" v-on:click="back">返回</div>
          <div class="greenText textbtn" v-on:click="sendEmail">確認</div>
        </div>
      </div>
      <div v-else>
        <p style="font-size:1.5em; line-height:1.5em">驗證郵件已發往您的郵箱。請查看您的郵箱以繼續重設密碼。</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
  primary:#397f1f, // The accent or secondary color
));

.greenText{
  color: #397f1f;
}

.loginPage{
  display: flex;
}
.textbtn{
  cursor: pointer;
}
.login-leftBox{
  flex: 5;
  background-color: #397f1f;
}
.login-graphic{
  position: relative;
  top: calc(50% - 100vh);
  left: calc(50% - 100vw);
  transform: translate(-50%, -50%) translate(100vw, 100vh);
  max-height: 100vh;
  padding: 5rem 2rem;
}
.center{
  display: flex;
  justify-content: center;
}
.login-rightBox{
  flex: 0 0 400px;
  padding: 2rem 1.5rem;
}

#loginForm{
  background-color: #f5f5f5;
  border-radius: 1rem;
  padding: 4rem 3rem 2rem 3rem;
  position: relative;
  top: 30%;
  transform: translateY(-50%);
  padding: 3rem 2rem;
}

.loginform-btns{
  padding-top: 1.5rem;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}

.loginform-input{
  padding: 0.5rem 0rem;
  display: flex;
  justify-content: space-between;
}
.login-learnbtn{
  background-color: #f7efd0;
  border-radius: 1rem;
  color: black;
  width: 55%;
  margin: auto;
}
input{
  padding: 0rem 1rem;
  flex: 1;
  border-radius: 1rem;
  width: 100%;
}
.login-policy{
  color: #878787;
  font-size:10px
}
input:focus{
  border-radius: 1rem;
  outline: none;
}

.loginform-label{
  flex: 0 0 40px;
  align-self: center;
}
.loginform-field{
  flex: 1;
}
</style>
<script>
export default {
  data () {
    return {
      email: '',
      emailSent: false
    }
  },
  methods: {
    back: function () {
      this.$router.go(-1)
    },
    sendEmail: function () {
      let fd = new FormData()
      fd.append('email', this.email)

      this.$store.dispatch('request', {
        method: 'post',
        route: 'recovery/request',
        data: fd
      }).then(res => {
        this.emailSent = true
      })
    }
  }
}
</script>
